package com.arenaproplay.admin.ui.utils

import kotlinx.browser.document
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Int8Array
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader
import org.w3c.files.get

/** Opens the browser file dialog and reads the chosen image into memory. */
fun pickImageFile(onSelected: (bytes: ByteArray, fileName: String, contentType: String) -> Unit) {
    val input = document.createElement("input") as HTMLInputElement
    input.type = "file"
    input.accept = "image/*"
    input.onchange = {
        val file = input.files?.get(0)
        if (file != null) {
            val name = file.name
            val type = file.type.ifBlank { "image/jpeg" }
            val reader = FileReader()
            reader.onload = {
                val result = reader.result
                if (result != null) {
                    val buffer: ArrayBuffer = result.unsafeCast<ArrayBuffer>()
                    // A Kotlin/JS ByteArray is an Int8Array at runtime.
                    val bytes = Int8Array(buffer).unsafeCast<ByteArray>()
                    onSelected(bytes, name, type)
                }
                null
            }
            reader.readAsArrayBuffer(file)
        }
        null
    }
    input.click()
}
